import EntryActionTypes from '../constants/EntryActionTypes';

const getOrCreateDampingCoefficientInCurrentBoard = () => ({
  type: EntryActionTypes.DAMPING_COEFFICIENT_IN_CURRENT_BOARD_GET_OR_CREATE,
});

const fetchDampingCoefficientsInCurrentBoard = () => ({
  type: EntryActionTypes.DAMPING_COEFFICIENTS_IN_CURRENT_BOARD_FETCH,
});

const createDampingCoefficient = (pointSystemId, data = {}) => ({
  type: EntryActionTypes.DAMPING_COEFFICIENT_CREATE,
  payload: {
    pointSystemId,
    data,
  },
});

const updateDampingCoefficient = (id, data) => ({
  type: EntryActionTypes.DAMPING_COEFFICIENT_UPDATE,
  payload: {
    id,
    data,
  },
});

const deleteDampingCoefficient = (id) => ({
  type: EntryActionTypes.DAMPING_COEFFICIENT_DELETE,
  payload: {
    id,
  },
});

export default {
  getOrCreateDampingCoefficientInCurrentBoard,
  fetchDampingCoefficientsInCurrentBoard,
  createDampingCoefficient,
  updateDampingCoefficient,
  deleteDampingCoefficient,
};

